/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MountAndConsumePrimaryContainerEntry } from '../../models/mount-and-consume-primary-container-entry';

export interface ConsumePrimaryContainer$Params {
  workCenterId: number;
      body: MountAndConsumePrimaryContainerEntry
}

export function consumePrimaryContainer(http: HttpClient, rootUrl: string, params: ConsumePrimaryContainer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, consumePrimaryContainer.PATH, 'post');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

consumePrimaryContainer.PATH = '/api/v1/PrimaryMaterial/{workCenterId}/Consume';
